/** Four strategic pillars of the OBA (aligned with organisational focus areas). */

function PillarCapitalIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 56 64"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <rect x="8" y="4" width="40" height="7" rx="1.5" />
      <rect x="10" y="15" width="36" height="5" rx="1" />
      <path d="M14 24h28l-2 36H16L14 24zm4 6l-1.5 26h5.5L23 30h-5zm9.5 0L25 56h6l1.5-26h-9zm9 0L34 56h5.5L38 30h-5.5z" />
      <rect x="18" y="58" width="20" height="3" rx="0.5" />
    </svg>
  );
}

const PILLARS: {
  heading: string;
  subtext: string;
  focusAreas: string[];
}[] = [
  {
    heading: "College",
    subtext:
      "Students learning & meaningful support to College — education, physical resource, and finance.",
    focusAreas: ["Education", "Physical Resource", "Finance"],
  },
  {
    heading: "Alumni",
    subtext: "Engagement & Networking",
    focusAreas: ["Membership", "Public Relations"],
  },
  {
    heading: "Finance",
    subtext: "Stability & branding visibility as a community asset.",
    focusAreas: ["Finance"],
  },
  {
    heading: "Legacy",
    subtext:
      "Repository of the college’s values, spirit, pride & history.",
    focusAreas: ["Public Relations"],
  },
];

export function AboutPillarsPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-brand-maroon">
        OBA
      </p>
      <h1 className="mt-2 font-display text-4xl font-bold text-brand-blue md:text-5xl">
        Our pillars
      </h1>
      <p className="mt-3 max-w-2xl text-sm text-brand-blue/75 leading-relaxed">
        Four focus areas that guide how we serve Mother Zahira and our alumni
        community.
      </p>

      <div
        className="mt-14 grid gap-12 md:grid-cols-4 md:gap-0"
        role="list"
      >
        {PILLARS.map((pillar, index) => (
          <div
            key={pillar.heading}
            role="listitem"
            className={[
              "flex flex-col items-center text-center",
              index > 0
                ? "border-t border-dotted border-brand-blue/20 pt-12 md:border-l md:border-t-0 md:pt-0 md:pl-8 md:ml-0 md:border-brand-blue/25"
                : "",
            ].join(" ")}
          >
            <h2 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-brand-maroon md:text-base">
              {pillar.heading}
            </h2>
            <p className="mt-3 max-w-[17rem] text-xs text-brand-blue/70 leading-relaxed sm:text-sm md:max-w-none">
              {pillar.subtext}
            </p>
            <PillarCapitalIcon className="mt-6 h-14 w-14 shrink-0 text-brand-blue md:h-16 md:w-16" />
            <ul className="mt-6 flex flex-col items-center gap-2">
              {pillar.focusAreas.map((label) => (
                <li key={label}>
                  <span className="inline-block rounded-full border border-brand-blue px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-brand-blue">
                    {label}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
